import {
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Input,
  TextField,
  FormControl,
  ListItemIcon,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import DonutChart from "../../components/charts/DonutChart";
import Layout from "../../components/layout/Layout";
import {
  addPlaylistToScreen,
  screenFlagOff,
  uncheckAssignedScreen,
} from "../../Redux/Actions/screenAction";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import "./setting.css";
import { ReactComponent as ScreenIcon } from "../../Assets/images/screenIcon.svg";
import { ReactComponent as UserProfileIcon } from "../../Assets/images/userprofileIcon.svg";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";
import { TextareaAutosize } from "@material-ui/core";
import { playlistFlagOff } from "../../Redux/Actions/playlistAction";
import { DesktopMac } from "@mui/icons-material";
import ListIcon from "@mui/icons-material/List";
import toast from "react-hot-toast";
// import DeleteModel from "../../components/deletemodel/DeleteModel";
import ConfirmModel from "../../components/confirmmodel/ConfirmModel";
import { tr } from "../../i18n";
import PresentCard from "../../components/present/PresentCard";
import ScreenshotCard from "../../components/screenshot/ScreenshotCard";
import { canEditCms } from "../../utils/accessControl";
function Setting({ user, socketRef }) {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const { screens, isUnChecked } = useSelector((state) => ({
    screens:state.Screen.screens,
    isUnChecked:state.Screen.isUnChecked
  }),shallowEqual);
  const { playlist } = useSelector((state) => state.Playlist);
  const [playlistInfo, setPlaylistInfo] = useState({});
  const [code, setCode] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [message, setMessage] = useState("");
  const [duration, setDuration] = useState(60);
  const [instantEvent, setInstantEvent] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const actionSuccessMap = {
    "close--app": "App closed successfully.",
    "launch--app": "App launched successfully.",
    "reset--app": "App reset successfully.",
    "reload--app": "App reloaded successfully.",
    "refresh--app": "App refresh successfully.",
  };
  useEffect(() => {
    setPlaylistInfo({
      ...screens.find((s) => s._id === params.id),
      screenAssigned: false,
    });
  }, [params.id]);
  useEffect(() => {
    if (isUnChecked) {
      setPlaylistInfo({ ...screens.find((s) => s._id === params.id) });
      dispatch(screenFlagOff());
    }
  }, [isUnChecked]);
  useEffect(() => {
    socketRef.current.emit("leaving--connection");
    socketRef.current.on("screen--connection--off", (obj) => {
      //  console.log(obj)
    });
  }, []);


  const submit = () => {
    socketRef?.current.emit("message", {
      message,
      duration,
      mac: playlistInfo.mac,
    });
    setOpenModel(false);
    setMessage("");
  };
  const emitAssignPlaylistToScreen = (c) => {
    const id = setTimeout(() => {
      const screen = screens.find((s) => s._id === c);
      // console.log(screen);
      if (screen !== null) {
        socketRef.current?.emit("event:delegate", {
          detail: { mac: screen?.mac, code: c },
        });
        clearTimeout(id);
      }
    }, 2000);
  };
  const screenHanlderSelect = (e) => {
    setCode(e.target.value);
    const mac = screens.find((c) => c._id === params.id);
    // console.log(e.target.value);
    dispatch(
      addPlaylistToScreen({
        id: params.id,
        value: e.target.value,
        mac: mac.mac,
      })
    );
    // setPlaylistInfo({...screens.find(s=>s._id===params.id),screenAssigned:true})
    emitAssignPlaylistToScreen(params.id);
  };
  return (
    <>
      {/* {
      console.log(playlistInfo)
    } */}
      <Layout title={tr("Setting")} user={user}>
        <Grid container>
          <Grid item lg={8} xs={12}>
            <Box
              sx={{
                background: "white",
                p: 2,
                margin: "18px 20px",
                borderRadius: "16px",
              }}
            >
              <div className="device flex flex-column">
                <div className="device-header flex flex-content-space-around alignItemCenter">
                  <div className="device-header-left flex">
                    <div className="screen-icon flex justifyContentCenter alignItemCenter">
                      <MobileFriendlyIcon
                        style={{ color: "#008080" }}
                      />
                    </div>
                    <div className="screen-text flex flex-column">
                      <p>{playlistInfo?.device_details?.device_name}</p>
                      {/* {playlistInfo?.onlinesStatus ? (
                        <span>Connected</span>
                      ) : (
                        <span>Disconnected</span>
                      )} */}
                    </div>
                  </div>
                  <div className="device-header-right flex">
                    <div className="playlist-selector flex flex-column justifyContentCenter alignItemCenter">
                      {/* {playlistInfo?.playlist === undefined ||
                      playlistInfo?.screenAssigned ? (
                        <select
                          className="deviceSelect"
                          value={code}
                          onChange={screenHanlderSelect}
                          style={{
                            height: "30px",
                            width: "200px",
                            margin: "0 20px",
                            background: "rgba(217, 217, 217, 0.3)",
                            border: "1px solid rgba(85, 31, 255, 0.1)",
                            color: "black",
                            borderRadius: "5px",
                          }}
                        >
                          <option>select Device</option>
                          {playlist &&
                            playlist.map((play) => (
                              <>
                                <option value={play._id}>{play.name}</option>
                              </>
                            ))}
                        </select>
                      ) : ( */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <ListIcon
                          style={{ color: "#008080",cursor:'pointer' }}
//                           onClick={() =>{
// console.log('sleected')
//                             dispatch(uncheckAssignedScreen(playlistInfo._id))
//                           }
//                           }
                        />
                        <p>{playlistInfo?.playlist?.name}</p>
                        {/* <BorderColorIcon
                            style={{ color: "#008080" }}
                            onClick={() =>
                              dispatch(uncheckAssignedScreen(playlistInfo._id))
                            }
                          /> */}
                      </Box>
                      {/* )} */}
                    </div>
                  </div>
                </div>
                <Grid container>
                  <Grid item xs={12} lg={8}>
                    <Grid
                      container
                      sx={{
                        borderBottom: "1px solid rgba(85, 31, 255, 0.2)",
                        pt: 2.5,
                        pb: 2.5,
                      }}
                    >
                      <Grid item xs={12} sm={6} lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            pl: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>{tr("Code")}</p>
                            <span>{playlistInfo.code}</span>
                          </div>
                          <div className="info-2">
                            <p>{tr("Device Name")}</p>
                            <span>
                              {playlistInfo?.device_details?.device_name}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            pl: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>{tr("Name")}</p>
                            <span>{playlistInfo.name}</span>
                          </div>
                          <div className="info-2">
                            <p>{tr("Manufacturing")}</p>
                            <span>
                              {playlistInfo?.device_details?.manufacturer}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      sx={{
                        borderBottom: "1px solid rgba(85, 31, 255, 0.2)",
                        pt: 2.5,
                        pb: 2.5,
                      }}
                    >
                      <Grid item xs={12} sm={6} lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>{tr("OS")}</p>
                            <span>
                              {playlistInfo?.device_details?.os_version}
                            </span>
                          </div>
                          <div className="info-2">
                            <p>{tr("Location")}</p>
                            <span>{playlistInfo?.location ?? "N/A"}</span>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>{tr("Mac Address")}</p>
                            <span>{playlistInfo.mac}</span>
                          </div>
                          <div className="info-2">
                            <p>{tr("Ip Address")}</p>
                            <span>{playlistInfo?.device_details?.ip || "—"}</span>
                          </div>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      sx={{
                        pt: 2.5,
                        pb: 2.5,
                      }}
                    >
                      <Grid item xs={12} sm={6} lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>{tr("Software")}</p>
                            <span>
                              {playlistInfo?.device_details?.software}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} lg={6}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            ml: 7,
                          }}
                        >
                          <div className="info-1">
                            <p>{tr("Root Level")}</p>
                            <span>
                              {playlistInfo?.device_details?.root_level}
                            </span>
                          </div>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        color: "#15192C",
                        fontSize: "18px",
                        py: 3,
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        {tr("Device Details")}
                      </Typography>
                    </Box>
                    <Box>
                      <div className="ram">
                        <DonutChart
                          views={"Ram"}
                          series={[
                            +playlistInfo?.ram?.total.split(" ")[0] -
                              +playlistInfo?.ram?.free.split(" ")[0],
                            +playlistInfo?.ram?.free.split(" ")[0],
                          ]}
                          labels={[
                            `Usage ${playlistInfo?.ram?.total.split(" ")[1]}`,
                            `Free ${playlistInfo?.ram?.free.split(" ")[1]}`,
                          ]}
                        />
                      </div>
                    </Box>
                    <Box>
                      <div className="storage">
                        <DonutChart
                          views={"Storage"}
                          series={[
                            +playlistInfo?.storage?.total.split(" ")[0] -
                              +playlistInfo?.storage?.free.split(" ")[0],
                            +playlistInfo?.storage?.free.split(" ")[0],
                          ]}
                          labels={[
                            `Usage ${
                              playlistInfo?.storage?.total.split(" ")[1]
                            }`,
                            `Free ${playlistInfo?.storage?.free.split(" ")[1]}`,
                          ]}
                        />
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </div>
            </Box>
          </Grid>
          <Grid item lg={4} xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // background: "var(--primary-color)",
                background: "white",
                padding: "15px 20px",
                color: "white",
                margin: "15px",
                borderRadius: "15px",
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {tr("Select Action")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={instantEvent}
                  onChange={(e) => setInstantEvent(e.target.value)}
                  variant={"outlined"}
                  label={tr("Select Action")}
                  sx={{
                    border: "1px solid white",
                    width: "100%",
                    margin: "0 auto",
                  }}
                >
                  <MenuItem
                    value={"Close App"}
                    onClick={() => {
                      setSelectedAction("close--app");
                      setOpenConfirm(true);
                    }}
                  >
                    {tr("Close App")}
                  </MenuItem>
                  <MenuItem
                    value={"Launch App"}
                    onClick={() => {
                      setSelectedAction("launch--app");
                      setOpenConfirm(true);
                    }}
                  >
                    {tr("Lauch App")}
                  </MenuItem>
                  <MenuItem
                    value={"Reset App"}
                    onClick={() => {
                      setSelectedAction("reset--app");
                      setOpenConfirm(true);
                    }}
                  >
                    {tr("Reset App")}
                  </MenuItem>
                  <MenuItem
                    value={"Reload App"}
                    onClick={() => {
                      setSelectedAction("reload--app");
                      setOpenConfirm(true);
                    }}
                  >
                    {tr("Reload App")}
                  </MenuItem>
                  <MenuItem
                    value={"Refresh App"}
                    onClick={() => {
                      setSelectedAction("refresh--app");
                      setOpenConfirm(true);
                    }}
                  >
                    {tr("Refresh App")}
                  </MenuItem>
                </Select>
              </FormControl>
              {/* <UserProfileIcon />
              <Typography
                sx={{
                  fontSize: "12px",
                  pl: 1,
                }}
              >
                User profile settings
              </Typography> */}
            </Box>
            <Box
              sx={{
                background: "white",
                p: 2,
                margin: "18px 20px",
                borderRadius: "16px",
              }}
            >
              <ScreenshotCard screenId={params.id} canEdit={canEditCms(user)} />
              <Box>
                <Typography
                  sx={{
                    color: "#15192C",
                    fontSize: "16px",
                    fontWeight: "bold",
                    mt: 3,
                  }}
                >
                  {tr("Detail:")}
                </Typography>
                <Typography
                  sx={{
                    color: "#92959E",
                    fontSize: "15px",
                  }}
                >
                  {tr("Send instant message on the screen.")}
                </Typography>
                <Button
                  variant={"outlined"}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "15px 20px",
                    color: "#008080",
                    margin: "15px",
                    borderRadius: "6px",
                    border: " 1px solid #008080",
                    mt: 3,
                    fontSize: "15px",
                    pl: 1,
                    width: {
                      xl: "300px",
                      lg: "300px",
                      md: "300px",
                      sm: "200px",
                      xs: "200px",
                    },
                    textTransform: "capitalize",
                  }}
                  onClick={() => setOpenModel(true)}
                >
                  {tr("Send Message")}
                </Button>



              </Box>
            </Box>
            <PresentCard screenId={params.id} canEdit={canEditCms(user)} />
          </Grid>
        </Grid>
      </Layout>

      <ConfirmModel
        open={openConfirm}
        onClose={setOpenConfirm}
        onConfirm={() => {
          if (!selectedAction) {
            setOpenConfirm(false);
            return;
          }
          socketRef.current.emit(
            selectedAction,
            {
              mac: playlistInfo?.mac,
            },
            () => toast.success(actionSuccessMap[selectedAction] || "Action completed." )
          );
          setOpenConfirm(false);
        }}
      />

      <Dialog
        // maxWidth={"xl"}
        fullWidth={true}
        open={openModel}
        onClose={() => setOpenModel(false)}
      >
        <DialogTitle
          style={{
            textAlign: "center",
            borderBottom: "2px solid #008080",
            fontSize: "18px",
            fontWeight: 700,
          }}
        >
          {tr("Send Message")}
        </DialogTitle>
        <DialogContent>
          <div className="screen-form">
            <div className="icon-screen">
              {/* <AddScreenIcon /> */}
              <MailOutlineIcon
                sx={{
                  color: "#008080",
                  height: "50px",
                  width: "50px",
                }}
              />
            </div>
            <div className="form-fields">
              <TextField
                type={"text"}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                variant={"outlined"}
                label={tr("Write Message")}
                multiline
                fullWidth
              />
            </div>

            <div className="form-fields">
              <TextField
                type={"number"}
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                sx={{
                  width: "100px",
                }}
              />
            </div>

            <Box
              sx={{
                display: "flex",
                mt: 8,
                mb: 5,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                style={{
                  background: "white",
                  padding: "8px",
                  width: "130px",
                  color: "#008080",
                  border: "1px solid #008080",
                  marginRight: "10px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => setOpenModel(false)}
              >
                {tr("Cancel")}
              </button>
              <button
                style={{
                  background: "#008080",
                  padding: "8px",
                  width: "130px",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={submit}
                className="btn primary"
              >
                {tr("Send")}
              </button>
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default Setting;
